/**
 * Comprehensive Phrases Data - Requests & Responses
 * 请求与回应短语集合
 *
 * 包含请求许可、回应请求等常用表达，约35个短语
 */

import { Phrase } from './phrases-types';

export const requestResponsePhrases: Phrase[] = [
  // ==================== 请求表达 Request Expressions ====================

  // 基本请求
  {
    id: 'request_can_i',
    phrase: 'Can I...?',
    phonetic: '/kæn aɪ/',
    meaning: '我可以……吗？',
    usageScenario: '请求许可或询问是否可以做某事，比较随意常用',
    example: 'Can I have some water?',
    exampleTranslation: '我可以要一些水吗？',
    category: 'requests',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'request_can_i_help',
    phrase: 'Can I help you?',
    phonetic: '/kæn aɪ help juː/',
    meaning: '我能帮你吗？',
    usageScenario: '主动提供帮助，是常用的礼貌表达',
    example: 'Can I help you with your homework?',
    exampleTranslation: '我能帮你做作业吗？',
    category: 'requests',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'request_can_you',
    phrase: 'Can you...?',
    phonetic: '/kæn juː/',
    meaning: '你能……吗？',
    usageScenario: '请求对方做某事或询问对方的能力',
    example: 'Can you help me, please?',
    exampleTranslation: '你能帮我一下吗？',
    category: 'requests',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'request_may_i',
    phrase: 'May I...?',
    phonetic: '/meɪ aɪ/',
    meaning: '我可以……吗？（更礼貌）',
    usageScenario: '礼貌地请求许可，比Can I更正式',
    example: 'May I come in?',
    exampleTranslation: '我可以进来吗？',
    category: 'requests',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'request_may_i_ask',
    phrase: 'May I ask...?',
    phonetic: '/meɪ aɪ æsk/',
    meaning: '我可以问……吗？',
    usageScenario: '礼貌地请求询问问题',
    example: 'May I ask a question?',
    exampleTranslation: '我可以问一个问题吗？',
    category: 'requests',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'request_could_you',
    phrase: 'Could you...?',
    phonetic: '/kʊd juː/',
    meaning: '你能……吗？（更礼貌）',
    usageScenario: '礼貌地请求对方做某事，比Can you更客气',
    example: 'Could you help me, please?',
    exampleTranslation: '你能帮我一下吗？',
    category: 'requests',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'request_could_you_please',
    phrase: 'Could you please...?',
    phonetic: '/kʊd juː pliːz/',
    meaning: '请您……好吗？',
    usageScenario: '非常礼貌地请求对方做某事',
    example: 'Could you please open the door?',
    exampleTranslation: '请您开门好吗？',
    category: 'requests',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'request_would_you',
    phrase: 'Would you...?',
    phonetic: '/wʊd juː/',
    meaning: '你愿意……吗？',
    usageScenario: '礼貌地请求或询问对方意愿',
    example: 'Would you help me?',
    exampleTranslation: '你愿意帮我吗？',
    category: 'requests',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'request_would_you_like',
    phrase: 'Would you like...?',
    phonetic: '/wʊd juː laɪk/',
    meaning: '你想要……吗？',
    usageScenario: '礼貌地询问对方是否想要某物或想做某事',
    example: 'Would you like some tea?',
    exampleTranslation: '你想要一些茶吗？',
    category: 'requests',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'request_would_you_like_to',
    phrase: 'Would you like to...?',
    phonetic: '/wʊd juː laɪk tuː/',
    meaning: '你想要……吗？（做某事）',
    usageScenario: '礼貌地邀请对方做某事',
    example: 'Would you like to play with us?',
    exampleTranslation: '你想要和我们一起玩吗？',
    category: 'requests',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'request_will_you',
    phrase: 'Will you...?',
    phonetic: '/wɪl juː/',
    meaning: '你会……吗？',
    usageScenario: '询问对方是否会做某事',
    example: 'Will you come to my party?',
    exampleTranslation: '你会来我的聚会吗？',
    category: 'requests',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'medium'
  },

  // 其他请求表达
  {
    id: 'request_let_me',
    phrase: 'Let me...',
    phonetic: '/let miː/',
    meaning: '让我……',
    usageScenario: '请求允许自己做某事',
    example: 'Let me help you.',
    exampleTranslation: '让我帮你。',
    category: 'requests',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'request_please_help',
    phrase: 'Please help me.',
    phonetic: '/pliːz help miː/',
    meaning: '请帮我。',
    usageScenario: '直接请求帮助',
    example: 'Please help me with this problem.',
    exampleTranslation: '请帮我解决这个问题。',
    category: 'requests',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'request_can_i_have',
    phrase: 'Can I have...?',
    phonetic: '/kæn aɪ hæv/',
    meaning: '我可以要……吗？',
    usageScenario: '请求得到某物',
    example: 'Can I have some apples?',
    exampleTranslation: '我可以要一些苹果吗？',
    category: 'requests',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'request_wait_a_minute',
    phrase: 'Wait a minute!',
    phonetic: '/weɪt ə ˈmɪnɪt/',
    meaning: '等一下！',
    usageScenario: '请求对方稍等片刻',
    example: 'Wait a minute! I am coming!',
    exampleTranslation: '等一下！我来了！',
    category: 'requests',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'request_just_a_minute',
    phrase: 'Just a minute!',
    phonetic: '/dʒʌst ə ˈmɪnɪt/',
    meaning: '就一分钟！',
    usageScenario: '请求对方稍等，强调时间很短',
    example: 'Just a minute! I need to finish this.',
    exampleTranslation: '等一下！我需要完成这个。',
    category: 'requests',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'request_wait_for_me',
    phrase: 'Wait for me!',
    phonetic: '/weɪt fɔːr miː/',
    meaning: '等等我！',
    usageScenario: '请求对方等待自己',
    example: 'Wait for me! I am almost ready.',
    exampleTranslation: '等等我！我快准备好了。',
    category: 'requests',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },

  // ==================== 回应表达 Response Expressions ====================

  // 肯定回应
  {
    id: 'response_yes',
    phrase: 'Yes.',
    phonetic: '/jes/',
    meaning: '是的。',
    usageScenario: '肯定回答或表示同意',
    example: 'Do you like apples? - Yes, I do.',
    exampleTranslation: '你喜欢苹果吗？- 是的，我喜欢。',
    category: 'responses',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'response_yes_please',
    phrase: 'Yes, please.',
    phonetic: '/jes pliːz/',
    meaning: '好的，请。',
    usageScenario: '接受别人的提议或帮助',
    example: 'Would you like some water? - Yes, please.',
    exampleTranslation: '你想要一些水吗？- 好的，请。',
    category: 'responses',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'response_yes_i_do',
    phrase: 'Yes, I do.',
    phonetic: '/jes aɪ duː/',
    meaning: '是的，我……',
    usageScenario: '肯定回答do提问的句子',
    example: 'Do you like it? - Yes, I do.',
    exampleTranslation: '你喜欢它吗？- 是的，我喜欢。',
    category: 'responses',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'response_ok',
    phrase: 'OK!',
    phonetic: '/oʊˈkeɪ/',
    meaning: '好的！/ 可以！',
    usageScenario: '表示同意或答应，非常常用的回应',
    example: "Let's play! - OK!",
    exampleTranslation: '让我们玩吧！- 好的！',
    category: 'responses',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'response_all_right',
    phrase: 'All right!',
    phonetic: '/ɔːl raɪt/',
    meaning: '好的！/ 行！',
    usageScenario: '表示同意或答应',
    example: "Let's go! - All right!",
    exampleTranslation: '我们走吧！- 好的！',
    category: 'responses',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'response_sure',
    phrase: 'Sure!',
    phonetic: '/ʃʊər/',
    meaning: '当然！/ 没问题！',
    usageScenario: '表示乐意做某事或同意',
    example: 'Can you help me? - Sure!',
    exampleTranslation: '你能帮我吗？- 当然！',
    category: 'responses',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'response_certainly',
    phrase: 'Certainly!',
    phonetic: '/ˈsɜːrtnli/',
    meaning: '当然！',
    usageScenario: '表示肯定或同意，比sure更正式',
    example: 'May I use your pen? - Certainly!',
    exampleTranslation: '我可以用你的钢笔吗？- 当然！',
    category: 'responses',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'response_of_course',
    phrase: 'Of course!',
    phonetic: '/əv kɔːrs/',
    meaning: '当然！',
    usageScenario: '表示肯定或同意，常用回应',
    example: 'Can I help you? - Of course!',
    exampleTranslation: '我能帮你吗？- 当然！',
    category: 'responses',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'response_no_problem',
    phrase: 'No problem!',
    phonetic: '/noʊ ˈprɒbləm/',
    meaning: '没问题！',
    usageScenario: '表示愿意做某事或答应请求',
    example: 'Can you do this? - No problem!',
    exampleTranslation: '你能做这个吗？- 没问题！',
    category: 'responses',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'response_good_idea',
    phrase: 'Good idea!',
    phonetic: '/ɡʊd aɪˈdiːə/',
    meaning: '好主意！',
    usageScenario: '赞同别人的提议或想法',
    example: "Let's go to the park. - Good idea!",
    exampleTranslation: '我们去公园吧。- 好主意！',
    category: 'responses',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'response_great_idea',
    phrase: 'Great idea!',
    phonetic: '/ɡreɪt aɪˈdiːə/',
    meaning: '太好了！好主意！',
    usageScenario: '非常赞同别人的提议',
    example: "Let's play basketball! - Great idea!",
    exampleTranslation: '我们打篮球吧！- 好主意！',
    category: 'responses',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'response_sounds_good',
    phrase: 'Sounds good!',
    phonetic: '/saʊnds ɡʊd/',
    meaning: '听起来不错！',
    usageScenario: '表示同意或喜欢某提议',
    example: "Let's have pizza for dinner. - Sounds good!",
    exampleTranslation: '我们晚餐吃披萨吧。- 听起来不错！',
    category: 'responses',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },

  // 否定回应
  {
    id: 'response_no',
    phrase: 'No.',
    phonetic: '/noʊ/',
    meaning: '不是。/ 没有。',
    usageScenario: '否定回答或表示不同意',
    example: 'Do you like rain? - No, I do not.',
    exampleTranslation: '你喜欢下雨吗？- 不，我不喜欢。',
    category: 'responses',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'response_no_thanks',
    phrase: 'No, thanks.',
    phonetic: '/noʊ θæŋks/',
    meaning: '不用了，谢谢。',
    usageScenario: '礼貌地拒绝提议或帮助',
    example: 'Would you like some coffee? - No, thanks.',
    exampleTranslation: '你想要一些咖啡吗？- 不用了，谢谢。',
    category: 'responses',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'response_no_i_dont',
    phrase: "No, I don't.",
    phonetic: '/noʊ aɪ doʊnt/',
    meaning: '不，我不……',
    usageScenario: '否定回答do提问的句子',
    example: 'Do you like it? - No, I don\'t.',
    exampleTranslation: '你喜欢它吗？- 不，我不喜欢。',
    category: 'responses',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'response_no_way',
    phrase: 'No way!',
    phonetic: '/noʊ weɪ/',
    meaning: '没门！/ 不可能！',
    usageScenario: '表示强烈的拒绝或不同意',
    example: "Can I have your bike? - No way!",
    exampleTranslation: '我能用你的自行车吗？- 没门！',
    category: 'responses',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'response_i_dont_think_so',
    phrase: "I don't think so.",
    phonetic: '/aɪ doʊnt θɪŋk soʊ/',
    meaning: '我不这么认为。',
    usageScenario: '礼貌地表达不同意见',
    example: 'Is this a good idea? - I don\'t think so.',
    exampleTranslation: '这是个好主意吗？- 我不这么认为。',
    category: 'responses',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'medium'
  },

  // 其他回应
  {
    id: 'response_i_agree',
    phrase: 'I agree.',
    phonetic: '/aɪ əˈɡriː/',
    meaning: '我同意。',
    usageScenario: '表示同意某人的观点或意见',
    example: 'I agree with you.',
    exampleTranslation: '我同意你的观点。',
    category: 'responses',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'response_i_disagree',
    phrase: 'I disagree.',
    phonetic: '/aɪ ˌdɪsəˈɡriː/',
    meaning: '我不同意。',
    usageScenario: '表示不同意某人的观点',
    example: "I disagree with that idea.",
    exampleTranslation: '我不同意那个想法。',
    category: 'responses',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'response_i_think_so',
    phrase: 'I think so.',
    phonetic: '/aɪ θɪŋk soʊ/',
    meaning: '我也这么认为。',
    usageScenario: '表示同意对方的看法',
    example: 'Is this book good? - I think so.',
    exampleTranslation: '这本书好吗？- 我也这么认为。',
    category: 'responses',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'response_thats_right',
    phrase: "That's right!",
    phonetic: '/ðæts raɪt/',
    meaning: '对了！/ 正确！',
    usageScenario: '确认对方说的话是正确的',
    example: 'You are from China. - That\'s right!',
    exampleTranslation: '你来自中国。- 对了！',
    category: 'responses',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'response_thats_wrong',
    phrase: "That's wrong.",
    phonetic: '/ðæts rɒŋ/',
    meaning: '那是错的。',
    usageScenario: '指出对方说的话不正确',
    example: 'You are ten years old. - That\'s wrong. I am nine.',
    exampleTranslation: '你十岁了。- 那是错的。我九岁。',
    category: 'responses',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'response_i_suppose',
    phrase: 'I suppose...',
    phonetic: '/aɪ səˈpoʊz/',
    meaning: '我想……/ 我猜……',
    usageScenario: '不太确定地表达看法',
    example: 'I suppose it will rain.',
    exampleTranslation: '我想会下雨。',
    category: 'responses',
    difficulty: 'hard',
    grade: '7',
    level: 'middle',
    frequency: 'low'
  },
];